<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import MainForm from "../../../components/payroll/arrearsexercise/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": MainForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      formData: {
        bpexercisecode: "",
        bpexercisedesc: "",
        inceffdate: null,
        actinceffdate: null,
        servicedate: null,
        posttopayoutid: null,
        posttopayoutcode: null,
        posted: false,
        exercisepo: [],
        exercisepayitem: [],
        exercisestatpayitem: [],
        exercisectrl: {
          dedtallw: false,
          dedtot: false,
          dedtbon: false,
          dedtbasic: false,
          dedtdedt: false,
          paydedt: false,
        },
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      pageTitle: this.$t('arrearsexercise.createarrearsexercise'),
      pageTitleValue: "",
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {
          url:  "/arrearsexercise/create",
          payload: this.formData
      })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "arrearsexerciselist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },
};
</script>

<style scoped>
</style>